import Messages from './messages.js'

/**
 * Represents a tag reading data
 * 
 * @typedef {Object} TagData
 * @property {string} id
 * @property {string} data
 */

/**
 * Represents a tag object with timestamp and tag reading
 * 
 * @typedef {Object} Tag
 * @property {number} timestamp
 * @property {TagData} tag
 */

export default class RfidClient {

  constructor(socket) {
    this.socket = socket
  }

  /**
   * Start RFID reading
   * 
   * @param {function(Tag|undefined):} onTag
   * @returns {Promise<RfidClient>}
   */
  async captureStart(onTag) {
    try {
      await this.socket.emitWithAck(Messages.Rfid_ReadStart);
    } catch (error) {
      console.error(`RfidClient : ${error}`)
      throw new Error('Socket Error')
    }

    this.socket.on(Messages.Rfid_Tag, (tagUpdate) => {
      onTag(tagUpdate)
    })
    return this
  }

  /**
   * Power off RPI
   * 
   * @returns {Promise<void>}
   */
  async cancel() {
    try {
      await this.socket.emitWithAck(Messages.Rfid_ReadStop);
    } catch (error) {
      console.error(`RfidClient : ${error}`)
      throw new Error('Socket Error')
    }
    return
  }
}